// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"c158de1f","665":"6a2a3832","861":"27b87705"}[chunkId] + ".chunk.js";
};